import React, { useEffect, useState } from "react";
import AcademyCoursePage from "./AcademyCoursePage";
import TechbotsAcademyDetails from "../const/TechbotsAcademtyData";
import Logger from "../../../utils/Logger";
import img from "../../../assets/images/offereings_techbots/RoboQuestCardImg.png";
import { fetchAcademyData } from "../data/services/AcademyData";
const OfferingsMainPage: React.FC = () => {
  const [academyData, setAcademyData] = useState(null);

  // useEffect(() => {
  //   // Fetch the JSON file from the public directory
  //   fetch("/techData.json")
  //     .then((response) => response.json())
  //     .then((data) => {
  //       // Update the path to images for the courses
  //       // data.course_list.forEach((course: { course_thumbnail: string }) => {
  //       //   // Just ensure the image path is correct relative to the public folder
  //       //   course.course_thumbnail = `../../../assets/images/${course.course_thumbnail}`;
  //       //   Logger.info("Image path ", course.course_thumbnail);
  //       // });
  //       setAcademyData(data);
  //     })
  //     .catch((error) => Logger.error("Error loading JSON data:", error));
  // }, []);
  useEffect(() => {
    const loadData = async () => {
      const data = await fetchAcademyData();
      if (data) {
        setAcademyData(data);
      }
    };
    loadData();
  }, []);
  if (!academyData) {
    return <div>Loading...</div>;
  }
  return <AcademyCoursePage academicData={academyData} />;
};

export default OfferingsMainPage;
